import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCalendarRegularPlaneIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 32 32",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M22.5 15a7.5 7.5 0 1 1 0 15 7.5 7.5 0 0 1 0-15m3.3 4-8.2 2h-.2a.5.5 0 0 0 0 1l2.6 1.3h.5l2.1-1.4a.2.2 0 0 1 .3.4L21.1 24l-.2.5.7 2.8v.2a.5.5 0 0 0 1 0l3.9-7.5a.6.6 0 0 0-.7-.9m-7-17q1.3.2 1.3 1.2v2h1.7c1.8 0 3.3 1.6 3.3 3.4V13a10 10 0 0 0-6.5.5H4.5v10q0 .6.8.7h7.5q.3 1.3.8 2.5H5.3A3.3 3.3 0 0 1 2 23.4V8.6c0-1.8 1.5-3.3 3.3-3.3h1.6v-2a1.2 1.2 0 1 1 2.5 0v2h8.2v-2Q17.7 2 19 2M5.4 7.8q-.8 0-.8.8V11h18V8.6q0-.8-.7-.8z" })
});
export default SvgCalendarRegularPlaneIcon;
